import { CellContext } from "@tanstack/react-table";
import { ChevronDown, ChevronRight } from "lucide-react";
import { ProductThumbnail } from "../../product-thumbnail";
import { VariantWithProductData } from "../types";
import { setImageCellTestId, setExpandButtonTestId } from "../products-table.utils";

interface ImageCellProps {
  onToggleExpansion?: () => void;
  onImageClick?: () => void;
  isExpanded?: boolean;
  canExpand?: boolean;
  isFirstVariant?: boolean;
}

export const ImageCellMarkup = ({
  row,
  onToggleExpansion,
  onImageClick,
  isExpanded = false,
  canExpand = false,
  isFirstVariant = true,
}: CellContext<VariantWithProductData, unknown> & ImageCellProps) => {
  const data = row.original;

  return (
    <div className="flex items-center gap-2" data-testid={setImageCellTestId(row.index)}>
      {isFirstVariant ? (
        <>
          {canExpand && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onToggleExpansion?.();
              }}
              className="text-muted-foreground hover:text-foreground transition-colors"
              aria-label={isExpanded ? "Collapse variants" : "Expand variants"}
              data-testid={setExpandButtonTestId(row.index)}
            >
              {isExpanded ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
            </button>
          )}
          <ProductThumbnail
            imageUrl={data.imageUrl ?? ""}
            productName={data.productTitle ?? ""}
            onClick={onImageClick ?? (() => {})}
            allowUpload={false}
          />
        </>
      ) : (
        <div className="w-full" />
      )}
    </div>
  );
};
